/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S2_R3_IdentityInputs */

const tr_kvkkbasvuru_s2_r3_identity = /** @type {(inputs: Kvkkbasvuru_S2_R3_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kimlik fotokopisi ekli ıslak imzalı`)
};

const en_kvkkbasvuru_s2_r3_identity = /** @type {(inputs: Kvkkbasvuru_S2_R3_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wet-signed with a copy of the identity document attached`)
};

const de_kvkkbasvuru_s2_r3_identity = /** @type {(inputs: Kvkkbasvuru_S2_R3_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigenhändig unterschrieben mit beigefügter Ausweiskopie`)
};

const ru_kvkkbasvuru_s2_r3_identity = /** @type {(inputs: Kvkkbasvuru_S2_R3_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`С собственноручной подписью и приложенной копией документа, удостоверяющего личность`)
};

/**
* | output |
* | --- |
* | "Wet-signed with a copy of the identity document attached" |
*
* @param {Kvkkbasvuru_S2_R3_IdentityInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s2_r3_identity = /** @type {((inputs?: Kvkkbasvuru_S2_R3_IdentityInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S2_R3_IdentityInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s2_r3_identity(inputs)
	if (locale === "de") return de_kvkkbasvuru_s2_r3_identity(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s2_r3_identity(inputs)
	return tr_kvkkbasvuru_s2_r3_identity(inputs)
});